import React from 'react';
import { Divider } from '@mui/material';

import { Typography, ContainerColumnLeft } from '@occc-app/design-system';

import { CardLayout } from '@occc/ui-design-system';
import { Purchase } from './Purchase';

import { Purchase as PurchaseAttribute } from '../../types';

interface IPurchasesProps {
  purchases: PurchaseAttribute[];
}

export const Purchases: React.FC<IPurchasesProps> = ({ purchases }) => {
  return (
    <ContainerColumnLeft>
      <CardLayout title='Transactions'>
        {purchases.map((item, index) => (
          <div key={index}>
            <Purchase attribute={item} />
            {index < purchases.length - 1 && (
              <>
                <Divider sx={{ my: 2, mx: 0 }} />
                <Typography variant='subtitle1' paragraph>
                  and
                </Typography>
              </>
            )}
          </div>
        ))}
      </CardLayout>
    </ContainerColumnLeft>
  );
};
